import { useSignupModal } from '@/zustand/store';

const useRedirectAfterLogin = () => {
  const setSignupModalOpen = useSignupModal((s) => s.setSignupModalOpen);
  const routerLogin = (signupSuccess?: () => void) =>
    setSignupModalOpen(true, { signupSuccess });

  return { routerLogin };
};

export default useRedirectAfterLogin;
